module.exports = __webpack_public_path__ + "static/assets/f05870a469bb80ae0aad61585c4f5dd3.png";